import { useQuery } from "@apollo/client/react";
import { Block, BlockTitle, Navbar, Page } from "framework7-react";
import { Fragment } from "react";
import { useSwipeable } from "react-swipeable";

import { NavLeftEmpty } from "@/components/NavLeftEmpty";
import { NavLeftPrev } from "@/components/NavLeftPrev";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavRightNext } from "@/components/NavRightNext";
import { NavTitle } from "@/components/NavTitle";
import { ReviewButtonBar } from "@/components/ReviewButtonBar";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { getFragmentData } from "@/generated/graphql";
import { GetWeeklyEvaluationDocument, WeeklyEvaluationFragmentDoc } from "@/generated/graphql/graphql";
import { usePageReady } from "@/hooks/usePageReady";
import { useEvaluationStore } from "@/stores/evaluationStore";

export const AIReviewPage = createPage("AIReviewPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { isPageReady, getPageProps } = usePageReady(pageName);
  const { weekly } = useEvaluationStore();

  const { data, refetch } = useQuery(GetWeeklyEvaluationDocument, {
    skip: !isPageReady,
    variables: { id: weekly.id },
  });
  const weeklyEvaluation = getFragmentData(WeeklyEvaluationFragmentDoc, data?.weeklyEvaluation);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: weekly.next,
    onSwipedRight: weekly.prev,
  });

  return (
    <Page
      ptr
      ptrMousewheel
      data-component={pageName}
      onPtrRefresh={(done) => {
        refetch().then(done);
      }}
      {...getPageProps()}
    >
      <Navbar>
        {weekly.disabledPrev ? <NavLeftEmpty /> : <NavLeftPrev onClick={weekly.prev} />}
        <NavTitle>{weekly.evaluation?.startOn}</NavTitle>
        {weekly.disabledNext ? <NavRightEmpty /> : <NavRightNext onClick={weekly.next} />}
      </Navbar>

      <div {...swipeHandlers}>
        {weeklyEvaluation?.attachments?.map((attachment) => (
          <img
            key={attachment.id}
            alt={attachment.filename}
            src={attachment.blobUrl}
          />
        ))}

        {weeklyEvaluation?.definitions?.map((definition) => (
          <Fragment key={definition.id}>
            <BlockTitle>{definition.title}</BlockTitle>
            <Block>{definition.body}</Block>
          </Fragment>
        ))}
      </div>

      <ReviewButtonBar activeButton="ai" />
    </Page>
  );
}
